import { render, staticRenderFns } from "./_dashboard.vue?vue&type=template&id=ac1a8310&scoped=true"
import script from "./_dashboard.vue?vue&type=script&lang=js"
export * from "./_dashboard.vue?vue&type=script&lang=js"
import style0 from "./_dashboard.vue?vue&type=style&index=0&id=ac1a8310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1a8310",
  null
  
)

export default component.exports